
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"#0C1D59","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zM12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm1 4.5v1.525c.888.051 1.564.187 2.088.47.733.397 1.041 1.021 1.26 1.466.017.031.032.062.046.092a1 1 0 11-1.788.894c-.277-.553-.33-.617-.469-.692C13.917 8.136 13.399 8 12 8c-1.305 0-1.899.223-2.167.39-.233.145-.305.289-.438.555v.002c-.13.26-.21.884.045 1.348.18.33.707.885 2.46.71 2.247-.225 3.72.47 4.415 1.74.62 1.136.45 2.462.08 3.202a.991.991 0 01-.063.108 4.357 4.357 0 01-2.063 1.678c-.425.164-.86.243-1.269.282V19.5a1 1 0 11-2 0v-1.488a6.674 6.674 0 01-1.34-.257c-.83-.26-1.833-.822-2.13-2.012a1 1 0 011.94-.486c.047.19.222.412.787.589.548.171 1.23.216 1.8.209.633-.008 1.099-.036 1.49-.187.324-.126.733-.37 1.08-.864.116-.282.173-.861-.067-1.3-.18-.329-.707-.884-2.46-.709-2.247.225-3.72-.47-4.415-1.74-.62-1.136-.45-2.462-.08-3.202l.02-.038c.149-.301.434-.876 1.15-1.322.54-.337 1.257-.562 2.225-.65V4.5a1 1 0 112 0z"}})])
          )
        }
      }
    